import {
  KUNCHAN_VALUE_TO_LABEL_MAP,
  INPUT_VALUE_KUN_CHAN_NASHI,
} from '@shared/jp/product';
import type { TKunChan } from '@shared/jp/product';

export const getKidstitle = (kunChan: TKunChan) =>
  kunChan === INPUT_VALUE_KUN_CHAN_NASHI
    ? ''
    : KUNCHAN_VALUE_TO_LABEL_MAP[kunChan];
